module.exports = __webpack_public_path__ + "img/1502727081.34849465.jpg";